import { render, staticRenderFns } from "./StakingInfo.vue?vue&type=template&id=c98a0388"
import script from "./StakingInfo.vue?vue&type=script&lang=js"
export * from "./StakingInfo.vue?vue&type=script&lang=js"
import style0 from "./StakingInfo.vue?vue&type=style&index=0&id=c98a0388&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports